import { render } from "./propertiesControls.vue?vue&type=template&id=21b07c22"
import script from "./propertiesControls.vue?vue&type=script&lang=js"
export * from "./propertiesControls.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__